var _rect, _text, _path, _circle, _path2, _text2, _text3, _text4, _circle2, _circle3, _circle4, _path3, _text5, _text6, _text7, _circle5, _rect2, _path4, _text8, _text9, _text0, _circle6, _path5, _path6, _text1, _text10, _text11, _circle7, _path7, _text12, _text13, _text14, _rect3, _circle8, _path8, _path9, _text15, _text16, _text17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportConnectedComplianceLoopFiveStageProcessMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 1090,
    viewBox: "0 0 620 1090",
    role: "img",
    "aria-label": "Connected compliance loop mobile diagram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 1090,
    rx: 38,
    fill: "#FFFFFF",
    stroke: "#D5E3F2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 44,
    y: 64,
    fill: "#087CFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.5
  }, "ONE CONNECTED COMPLIANCE LOOP")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 148v680",
    stroke: "#BBD9F5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 152,
    r: 37,
    fill: "#087CFF",
    fillOpacity: 0.12,
    stroke: "#087CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2 161.9l7.2-7.2 5.4 4.5 10.8-12.6",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 137,
    fill: "#087CFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 169,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "Detect")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 199,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 16,
    fontWeight: 650
  }, "Upcoming risk identified")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 302,
    r: 37,
    fill: "#F54291",
    fillOpacity: 0.12,
    stroke: "#F54291"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.7,
    cy: 295.7,
    r: 4.5,
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.2,
    cy: 296.6,
    r: 3.6,
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6 313.7c0-7.2 16.2-7.2 16.2 0M94.7 312.8c0-5.4 12.6-5.4 12.6 0",
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 287,
    fill: "#F54291",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "02")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 319,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "Group")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 349,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 16,
    fontWeight: 650
  }, "Efficient cohort proposed")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 452,
    r: 37,
    fill: "#F5AE35",
    fillOpacity: 0.12,
    stroke: "#F5AE35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.4,
    y: 441.2,
    width: 25.2,
    height: 22.5,
    rx: 2.7,
    fill: "none",
    stroke: "#F5AE35",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4 448.4h25.2M85.7 437.6v6.3M98.3 437.6v6.3",
    fill: "none",
    stroke: "#F5AE35",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 437,
    fill: "#F5AE35",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "03")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 469,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "Schedule")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 499,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 16,
    fontWeight: 650
  }, "Options and deadline issued")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 602,
    r: 37,
    fill: "#4BB5FF",
    fillOpacity: 0.12,
    stroke: "#4BB5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3 612.8v-21.6h23.400000000000002v21.6M85.7 597.5h12.6M85.7 603.8h9",
    fill: "none",
    stroke: "#4BB5FF",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6 609.2l3.6 3.6 7.2-8.1",
    fill: "none",
    stroke: "#4BB5FF",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 587,
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "04")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 619,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "Train")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 649,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 16,
    fontWeight: 650
  }, "Accredited delivery completed")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 752,
    r: 37,
    fill: "#30D6A1",
    fillOpacity: 0.12,
    stroke: "#30D6A1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.8 746.6a12.6 12.6 0 1 0 0.9 13.5M102.8 746.6v-7.2m0 7.2h-7.2",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 737,
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "05")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 769,
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 25,
    fontWeight: 850
  }, "Update")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 799,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 16,
    fontWeight: 650
  }, "Evidence and passport refreshed")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 896,
    width: 536,
    height: 142,
    rx: 28,
    fill: "#07152A"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 967,
    r: 31,
    fill: "#30D6A1",
    fillOpacity: 0.15
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100 953.88l11.479999999999999 4.1v8.2c0 7.38-4.92 12.299999999999999-11.479999999999999 15.579999999999998-11.479999999999999-3.28-11.479999999999999-8.2-11.479999999999999-15.579999999999998v-8.2z",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.9679999999999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.26 967l4.1 4.1 8.2-9.02",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.9679999999999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 152,
    y: 950,
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "RESULT")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 152,
    y: 985,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 22,
    fontWeight: 850
  }, "Worker remains site ready")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 152,
    y: 1012,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Current evidence updates the live passport.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportConnectedComplianceLoopFiveStageProcessMobile);
export default __webpack_public_path__ + "static/media/work-passport-connected-compliance-loop-five-stage-process-mobile.43d8eafc182720a52a3c40b07b502b66.svg";
export { ForwardRef as ReactComponent };